"use client";

import { useState } from "react";
import { Form, Input, Button, Typography, Result, Descriptions, Space } from "antd";
import { SearchOutlined, FileTextOutlined } from "@ant-design/icons";
import service from "../api/FetchInterceptor";
import logo from '../assets/images/LOGO_DNC.jpeg';

const { Title, Paragraph } = Typography;

const VerifyDocument = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null); // { found, ...fichier } | null
    const [notFound, setNotFound] = useState(false);

    const onVerify = async ({ reference }) => {
        setLoading(true);
        setResult(null);
        setNotFound(false);

        try {
            const response = await service({
                method: "GET",
                url: `verify-fichier/${encodeURIComponent(reference.trim())}`,
            });

            setResult(response);
        } catch (error) {
            if (error.response?.status === 404) {
                setNotFound(true);
            } else {
                setNotFound(true);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col min-h-screen items-center justify-center md:bg-blue-50">
            <img src={logo} alt="Espace AC | DNC" className="w-50 -mt-32" />

            <div className="w-full max-w-xl mx-4 p-6 rounded-lg bg-white mt-8 shadow">
                <Title level={3}>Vérification de document</Title>

                <Paragraph>
                    Saisissez la référence indiquée sur le document (ou encodée dans son
                    QR code) pour vérifier son authenticité.
                </Paragraph>

                <Form form={form} layout="vertical" onFinish={onVerify} className="mt-4">
                    <Form.Item
                        label="Référence du document"
                        name="reference"
                        rules={[{ required: true, message: "La référence est requise" }]}
                    >
                        <Input
                            placeholder="Ex : DNCMP-2026-000123"
                            size="large"
                            prefix={<SearchOutlined />}
                        />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        loading={loading}
                    >
                        Vérifier
                    </Button>
                </Form>

                {result?.found && (
                    <Result
                        status="success"
                        title="Document authentique"
                        subTitle="Cette référence correspond bien à un document émis par la DNC."
                        className="mt-4 !p-0"
                    >
                        <Descriptions column={1} bordered size="small">
                            <Descriptions.Item label="Référence">
                                {result.reference}
                            </Descriptions.Item>
                            <Descriptions.Item label="Intitulé">
                                {result.libelle || "—"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Date d'émission">
                                {result.created_at
                                    ? new Date(result.created_at).toLocaleDateString("fr-FR")
                                    : "—"}
                            </Descriptions.Item>
                        </Descriptions>

                        {result.path && (
                            <Space className="mt-4">
                                <Button
                                    icon={<FileTextOutlined />}
                                    href={result.path}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Consulter le document
                                </Button>
                            </Space>
                        )}
                    </Result>
                )}

                {notFound && (
                    <Result
                        status="error"
                        title="Document non reconnu"
                        subTitle="Aucun document ne correspond à cette référence. Vérifiez la saisie ou contactez la DNC"
                        className="mt-4 !p-4"
                    />
                )}
            </div>
        </div>
    );
};

export default VerifyDocument;
